export const ENVIRONMENT_INTERNAL = 'INTERNAL';
export const ENVIRONMENT_EXTERNAL = 'EXTERNAL';
export const ENVIRONMENT_INTERNAL_EXTERNAL = 'INTERNAL_EXTERNAL';

export const ENVIRONMENT_ENUMS = [ENVIRONMENT_INTERNAL, ENVIRONMENT_EXTERNAL, ENVIRONMENT_INTERNAL_EXTERNAL];
